import React from 'react'
import Radium from 'radium'
import { semanticColors } from '../../../../../Globals/styles'
import SuggestSelectInput from '../../../../../Common/suggestSelectInput';

const Cell = ({ content, style, inputStyle, readOnly, onChange, onFocus, onFocusOut, onClick, inputClassName, children, ref, onQuery, suggestions, onSelected }) => {
    return (
        <div style={[styles.cell, style]}
            onClick={() => { onClick ? onClick() : {} }}>
            <SuggestSelectInput
                className={inputClassName}
                onQuery={onQuery}
                suggestions={suggestions}
                placeholder="..."
                onChange={(val) => {
                    if (onChange) {
                        if(val.id) {
                            onSelected(val)
                        }
                        onChange(val)
                    }
                }} 
                ref={ref ? ref : undefined}
                value={content}
                style={[styles.input, inputStyle]}
                inputStyle={inputStyle}
                onFocus={() => onFocus ? onFocus() : {}}
                onBlur={() => onFocusOut ? onFocusOut() : {}}
                />
            {children}
        </div>
    );
}

const styles = {
    cell: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    },
    input: {
        '-webkit-appearance': 'none',
        '-moz-appearance':    'none',
        '-webkit-border-radius': '0px',
        cursor: 'pointer',
        width:' 100%',
        height: '35px',
        border: 'none',
        padding: '5px'
    },
}

export default Radium(Cell);


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Tilbud/spreadsheets/table/cellSuggest.js